<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <h1>Registrierung</h1>
        <v-form>
          <v-text-field v-model="username" label="Benutzername" outlined></v-text-field>
          <v-text-field v-model="email" label="E-Mail" outlined></v-text-field>
          <v-text-field v-model="password" label="Passwort" type="password" outlined></v-text-field>
          <v-text-field v-model="confirmPassword" label="Passwort bestätigen" type="password" outlined></v-text-field>
          <v-btn block color="primary" @click="register">Registrieren</v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
    };
  },
  methods: {
    async register() {
      if (this.password !== this.confirmPassword) {
        alert('Die Passwörter stimmen nicht überein.');
        return;
      }

      try {
        const response = await axios.post('https://bossel.fluidmans.de/bosseln-app-backend/api/auth/register', {
          username: this.username,
          email: this.email,
          password: this.password,
        });

        if (response.status === 201) {
          alert('Registrierung erfolgreich. Bitte melde dich an.');
          this.$router.push('/login');
        }
      } catch (error) {
        console.error(error);
        alert('Fehler bei der Registrierung. Bitte versuche es erneut.');
      }
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
}
</style>
